import React from "react";
import "./WhyChooseClybourne.css";

const WhyChooseClybourne = () => {
  const cards = [
    {
      title: "AI Precision",
      description:
        "Cutting-edge algorithms delivering real-time, accurate data.",
    },
    {
      title: "Expert Insights",
      description: "Seasoned professionals guiding every valuation.",
    },
    {
      title: "Seamless Experience",
      description: "A user-friendly valuation platform for efficient outcomes.",
    },
  ];

  return (
    <section className="why-choose-section">
      <div className="valuation-content WhyChooseClybourneMax-width">
        <h2 className="why-title">Why Choose Clybourne?</h2>
        <h1 className="why-sub-title">
          Valuation Simplified, Accuracy Amplified
        </h1>
        <p className="why-description">
          We redefine the valuation experience by combining:
        </p>
      </div>
      <div className="valuation-cards">
        {cards.map((card, index) => (
          <div className="card-why" key={index}>
            <div className="card-why2">
              <div className="card-icon-why">
                <img
                  src="/assets/images/ValuationApproach/Vector.png"
                  alt="↗"
                />
              </div>
              <h3>{card.title}</h3>
            </div>
            <p>{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseClybourne;
